
import styled from "styled-components";
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TableCell from '@mui/material/TableCell';
import {useState,Fragment,useEffect} from "react";
import Collapse from '@mui/material/Collapse';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { estadoCuenta } from "../../../redux/actions/cuentasActions.js";
import api from '../../../axios.js';
import { useDispatch } from 'react-redux'
import AddGameToUser from  "./addGame/addGameToUser.jsx"
import Card from "../../juegos/card.jsx"
import LocalOfferIcon from '@mui/icons-material/LocalOffer';


const NoGames=styled.div`
	font-size:25px
`;


export default function RowTableCuentas(props) {
  const { row ,isItemSelected,handleClick, labelId,setAddGame,setOpenNewGame} = props;
  const [open, setOpen] =useState(false);
  let dispatch=useDispatch();
  let [openAddGame,setOpenAddGame]=useState({id:"",status:false});
  let [cuentasUser,setCuentasUser]=useState([]);
  


let addgame=async(id)=>{
	setOpenAddGame({id:id,status:true})
}

function formatFecha(fecha) {
  return new Date(fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

let deleteGame=async(juego)=>{
	console.log(juego);
	if(window.confirm(`Desea eliminar el juego ${juego.Cuenta_Juego.Juego.nombre}`)){
		dispatch(estadoCuenta(1));
		let id_cuenta= juego.tipo_cuenta=="secundaria"?juego.Cuenta_Juego.cuentaId:juego.CuentaJuegoId;
		try{
			let rsp = await api.delete(`/usuario/deleteGame?reventaId=${juego.id}&tipoCuenta=${juego.tipo_cuenta}&idCuenta=${id_cuenta}&idUser=${juego.UserId}`);
			alert (rsp.data);
		getDatos();
		}catch(err){console.log(err);alert("error al grabar los datos")}
		dispatch(estadoCuenta(0));
	}
}

let getDatos=async()=>{
	api(`/reventa/user?id=${row.id}`)
			.then(response=> {setCuentasUser(response.data)} )
}

useEffect(()=>{
		
			getDatos()
	
},[openAddGame,open])

  return(
  		<Fragment>
  					{openAddGame.status?<AddGameToUser  user={row}  setOpen={setOpenAddGame}/>:null	}	
            <TableRow   hover role="checkbox" aria-checked={isItemSelected} tabIndex={-1} key={row.id} selected={isItemSelected} sx={{ cursor: 'pointer' }}>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                         onClick={(event) => handleClick(event, row.id)}
                        checked={isItemSelected}
                        inputProps={{
                          'aria-labelledby': labelId,
                        }}
                      />
                    </TableCell>
                    <TableCell  sx={{fontSize:"12px"}}>{row.id}</TableCell>
                    <TableCell  sx={{fontSize:"12px"}}>{row.nombre}</TableCell>
                    <TableCell  sx={{fontSize:"12px"}}>{row.usuario}</TableCell>
                    <TableCell  sx={{fontSize:"12px"}}>{row.correo}</TableCell>
                    <TableCell  sx={{fontSize:"12px"}}>{row.telefono}</TableCell>
                    <TableCell  sx={{fontSize:"12px"}}>{row.pais}</TableCell>
                    <TableCell  sx={{fontSize:"12px"}}>{row.tipo}</TableCell>
                    <TableCell  sx={{fontSize:"12px"}}>{row.fecha}</TableCell>
                    <TableCell align="center" >
                    	<IconButton  size="small" onClick={()=>addgame(row.id)} >
            				 		<AddIcon sx={{color:"#21D014"}} /> 
          						</IconButton>
        						</TableCell>
                    <TableCell align="right">
                    	<IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)} >
            				{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          				</IconButton>
        			</TableCell>
            </TableRow>
             <TableRow sx={{ cursor: 'pointer'}} >
        			<TableCell sx={{ paddingBottom: open?"55px":0, paddingTop: open?"55px":0, width:"100%"}} colSpan={10}>
			          <Collapse in={open} timeout="auto" unmountOnExit>
			            <Box sx={{ margin: 1, display: 'flex', justifyContent: 'flex-end',width:"100%",flexDirection:"column", p: 1 }}>
			              <Typography variant="h6" gutterBottom component="div">
			                {`Juegos de ${row.usuario} (${row.correo})`} 
			              </Typography>
			              {
			              	Object.keys(cuentasUser).length>0 ?
			              <Table size="small" aria-label="purchases" sx={{width:"100%" }}>
			                <TableHead>
			                  <TableRow>
			                  	<TableCell  align="right" ></TableCell>
			                  	<TableCell  align="right" >juego</TableCell>
			                    <TableCell  align="right" >consola</TableCell>
			                    <TableCell  align="right" >playstation id</TableCell>
			                    <TableCell  align="right" >correo</TableCell>			                    
			                    <TableCell  align="right" >fecha adquisicion</TableCell>
			                    <TableCell  align="right" >tipo cuenta</TableCell>
			                    <TableCell  align="right" ></TableCell>
			                  </TableRow>
			                </TableHead>
			                <TableBody>			                  
			                  {cuentasUser.map((cuenta) => (
			                  	cuenta.vendido?null:
			                    	<TableRow key={cuenta.id} >
			                    			<TableCell  align="right" >
			                    					<div style={{width:"60px",height:"70px",position:"relative"}}>
			                    						{cuenta.publicar_reventa?<LocalOfferIcon sx={{position:"absolute",color:"yellow",fontSize:"20px"}}/>:null}
			                    						<Card  consola={cuenta.consola}poster={cuenta.Cuenta_Juego.Juego.poster}/>
			                    				</div>
			                    			</TableCell>
			                    			<TableCell  align="right" >{cuenta.Cuenta_Juego.Juego.nombre}</TableCell>
			                      		<TableCell  align="right" >{cuenta.consola}</TableCell>
			                    			<TableCell  align="right" >{cuenta.Cuenta_Juego.Cuentum.playstation_id}</TableCell>
			                      		<TableCell  align="right" >{cuenta.Cuenta_Juego.Cuentum.correo}</TableCell>			                      		
			                      		<TableCell  align="right" >{formatFecha(cuenta.createdAt)}</TableCell>
			                      		<TableCell  align="right" >{cuenta.tipo_cuenta}</TableCell>
			                
			                      		<TableCell align="right"><RemoveIcon onClick={()=>deleteGame(cuenta)} size="small" sx={{color:"red"}} /></TableCell>
			                    	</TableRow>
			                  	))}
			                </TableBody>
			              </Table>:
			              <NoGames>Sin juegos asignados</NoGames>
			            }

			            </Box>
			          </Collapse>
			        </TableCell>
			      </TableRow>
                	
		 </Fragment>




  	)}